import { styled } from '@mui/system';

export const SimulationContainer = styled('div')(({ theme }) => ({
	'@media (min-width: 1400px)': {
		marginTop: 55
	},
	marginTop: 10
}));

export const SimulationContentContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'top',
	'@media (max-width: 855px)': {
		flexWrap: 'wrap'
	}
}));
